define({
  FETCH_MORE: 'FETCH_MORE',
  SHOW_MORE: 'SHOW_MORE',
  DELETE: 'DELETE',
  ACTIVATE: 'ACTIVATE',
  DEACTIVATE: 'DEACTIVATE',
  CHECK_ALL: 'CHECK_ALL',
  UPLOAD_DONE: 'UPLOAD_DONE',
  UPLOAD_EMPTY_CONTENT: 'UPLOAD_EMPTY_CONTENT',
  DOWNLOAD_DONE: 'DOWNLOAD_DONE',
  CLOSE: 'CLOSE',
  DONE: 'DONE',
  SUBMIT: 'SUBMIT'
});



/** WEBPACK FOOTER **
 ** ./target/js/shared/util/Events.js
 **/